<template>
  <b-table
    :items="gameSummaryData.fighter_stats"
    :fields="fields"
    responsive
    ref="table"
  >
    <template v-slot:custom-foot>
      <tr>
        <th>Total</th>
        <th>
          {{ gameSummaryData.total_games }}
        </th>
        <th>
          {{ gameSummaryData.victories }}
        </th>
        <th :class="winRatioClass(null, null, gameSummaryData)">
          {{ formatWinRatio(null, null, gameSummaryData) }}
        </th>
      </tr>
      <tr>
        <th>Average</th>
        <th></th>
        <th></th>
        <th :class="averageClass">
          {{ formattedAverageWinRate }}
        </th>
      </tr>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "GameSummary",
  props: {
    deckId: {
      type: String,
      required: true,
    },
    gameSummaryData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      countedGames: 0,
      fields: [
        { key: "name", label: "Name", sortable: true },
        {
          key: "total_games",
          label: "Games",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "victories",
          label: "Wins",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "percent",
          label: "Win %",
          formatter: "formatWinRatio",
          sortByFormatted: true,
          tdClass: this.winRatioClass,
          // class: "text-center",
          // slug: label.slug,
          sortable: true,
          sortDirection: "desc",
        },
      ],
    };
  },
  computed: {
    averageWinRate() {
      if (this.gameSummaryData.fighter_stats) {
        const initialVals = { avg: 0, n: 0 };
        const averageWinRate = this.gameSummaryData.fighter_stats.reduce(
          this.getAverageWinRate,
          initialVals
        );
        return averageWinRate.avg;
      }
      return null;
    },
    formattedAverageWinRate() {
      if (this.averageWinRate === null) {
        return "-";
      }
      return this.averageWinRate.toLocaleString("en", {
        style: "percent",
      });
    },
    averageClass() {
      if (this.averaWinRate === null) {
        return "";
      }
      return `resultgrid-bg${Math.round(this.averageWinRate * 10)}`;
    },
  },
  methods: {
    getAverageWinRate({ avg, n }, fighterInfo) {
      if (
        fighterInfo.victories !== null &&
        fighterInfo.total_games >= this.countedGames
      ) {
        const winRate = fighterInfo.victories / fighterInfo.total_games;
        return {
          avg: (winRate + n * avg) / (n + 1),
          n: n + 1,
        };
      }
      // skip to the next one
      return { avg, n };
    },
    formatWinRatio(_, __, value) {
      if (value.victories !== null && value.total_games > 0) {
        return (value.victories / value.total_games).toLocaleString("en", {
          style: "percent",
        });
      }
      return "-";
    },
    winRatioClass(_, __, value) {
      const winRatioClasses = [];
      if (value.victories !== null) {
        if (value.total_games < this.countedGames) {
          winRatioClasses.push("resultgrid-filtered");
        }
        const winRatio = value.victories / value.total_games;
        winRatioClasses.push(`resultgrid-bg${Math.round(winRatio * 10)}`);
      }
      return winRatioClasses;
    },
  },
};
</script>

<style>
/*
    Colourblindness friendly palette from
    https://gka.github.io/palettes/#/11|d|005a74,3aa794,e7e3bc|e7e3bc,eda34e,db4325|1|1

    Text contrast checked here: https://webaim.org/resources/contrastchecker/;
*/

.resultgrid-bg10 {
  background-color: #005a74;
  color: #fff;
}
.resultgrid-bg9 {
  background-color: #2a7781;
  color: #fff;
}
.resultgrid-bg8 {
  background-color: #51948f;
  color: #000;
}
.resultgrid-bg7 {
  background-color: #7db09d;
  color: #000;
}
.resultgrid-bg6 {
  background-color: #afcaac;
  color: #000;
}
.resultgrid-bg5 {
  background-color: #e7e7bc;
  color: #000;
}
.resultgrid-bg4 {
  background-color: #edc68e;
  color: #000;
}
.resultgrid-bg3 {
  background-color: #eda869;
  color: #000;
}
.resultgrid-bg2 {
  background-color: #e9894c;
  color: #000;
}
.resultgrid-bg1 {
  background-color: #e36935;
  color: #000;
}
.resultgrid-bg0 {
  background-color: #db4325;
  color: #000;
}
</style>
